import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f84fd38"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "addWorkModal",
  tabindex: "-1",
  "aria-labelledby": "addWorkModal",
  "aria-hidden": "true",
  "data-bs-focus": "false"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title w-100 text-center fw-bold" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "d-flex align-items-center mb-2" }
const _hoisted_9 = { class: "form-label mb-0 me-2" }
const _hoisted_10 = { class: "d-flex" }
const _hoisted_11 = { class: "me-2 width-select" }
const _hoisted_12 = { value: "" }
const _hoisted_13 = ["value"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = { class: "d-flex align-items-center mb-2" }
const _hoisted_18 = { class: "form-label mb-0 me-2" }
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_21 = { class: "mb-3" }
const _hoisted_22 = { class: "d-flex align-items-center mb-2" }
const _hoisted_23 = { class: "form-label mb-0 me-2" }
const _hoisted_24 = { class: "d-flex mb-2" }
const _hoisted_25 = { class: "w-max-content col-form-label text-left me-2 text-nowrap" }
const _hoisted_26 = { class: "w-100" }
const _hoisted_27 = { value: "" }
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "d-flex mb-2" }
const _hoisted_30 = { class: "w-max-content col-form-label text-left me-2 text-nowrap" }
const _hoisted_31 = { class: "w-100" }
const _hoisted_32 = { value: "" }
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "mb-3" }
const _hoisted_35 = { class: "d-flex align-items-center mb-2" }
const _hoisted_36 = { class: "form-label mb-0 me-2" }
const _hoisted_37 = ["placeholder"]
const _hoisted_38 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_39 = { class: "mb-3" }
const _hoisted_40 = { class: "d-flex align-items-center mb-2" }
const _hoisted_41 = { class: "form-label mb-0 me-2" }
const _hoisted_42 = { class: "d-flex flex-lg-row flex-column" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    for: "select-birthday",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-sm-4 mx-0 d-flex mt-2" }, /*#__PURE__*/_toDisplayString('～'), -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    for: "select-birthday",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_46 = { class: "fs-75 mt-2" }
const _hoisted_47 = { class: "mb-4" }
const _hoisted_48 = { class: "d-flex align-items-center mb-2" }
const _hoisted_49 = { class: "form-label mb-0 me-2" }
const _hoisted_50 = ["placeholder"]
const _hoisted_51 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_52 = {
  key: 1,
  class: "d-flex justify-content-center mb-4"
}
const _hoisted_53 = {
  key: 2,
  class: "row mx-0 px-0 mb-4 d-flex justify-content-center flex-lg-row flex-column-reverse"
}
const _hoisted_54 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center" }
const _hoisted_55 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center mb-4 mb-lg-0" }

import { computed, ref, onMounted, watchEffect, PropType, watch, nextTick } from 'vue'
import { useStore } from 'vuex'
import useVuelidate from '@vuelidate/core'
import { required, minLength } from '@vuelidate/validators'
import { customMaxLength, scrollToErrors } from '@/utils'
import flatPickr from 'vue-flatpickr-component'
import dayjs from 'dayjs'
import { useRouter } from 'vue-router'
import { translate } from '@/languages/i18n'
import Status from '@/components/status/index.vue'

import SuccessModal from '@/views/user/account/portfolio/components/SuccessModal.vue'
import ConfirmModal from '@/views/user/account/portfolio/components/ConfirmModal.vue'
import Button from '@/components/button/index.vue'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import ErrorMessage from '@/components/error-message/index.vue'

import { DEFAULT_MIN_LENGTH, MAX_WORD } from '@/constants/number'
import { COMMUNITY_PORTFOLIOS_STORE, REGISTER_STORE, ROOT_STORE } from '@/store/constants'
import { REGEX_EMOJI } from '@/constants/regex'

import { configYMPortfolio } from '@/constants/datepicker'
import { debounce } from 'lodash'
import commonService from '@/services/common.service'
import _, { cloneDeep } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  props: {
  idCorporation: String,
  idWork: String,
  errorCreateDepartment: String,
  handleEditWork: Function as PropType<any>,
  createDepartmentError: Function as PropType<any>,
  resetDataEditFlag: {
    type: Boolean,
    default: false,
  },
},
  emits: ['toogleModalAddWork', 'resetAffiliationModal'],
  setup(__props, { emit }) {

const props = __props

const isSameOrBefore = require('dayjs/plugin/isSameOrBefore')
const isSameOrAfter = require('dayjs/plugin/isSameOrAfter')

dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)

const store = useStore()
const router = useRouter()
const fromDateInput = ref()



const departments = computed(() => store.getters[COMMUNITY_PORTFOLIOS_STORE.GETTERS.PORTFOLIOS_DEPARTMENTS])
const listJobs = computed(() => store.getters[REGISTER_STORE.GETTERS.LIST_JOBS])
const portfolios = computed(() => store.getters[COMMUNITY_PORTFOLIOS_STORE.GETTERS.COMMUNITIES_PORTFOLIOS])
const isMobile = computed(() => store.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])

const indexJob = ref()
const subJob = ref([])
const jobNameParent = ref('')
const jobNameChild = ref('')
const departmentName = ref('')
const serverErrorPortfolios = ref('')
const requiredFromDate = ref(false)
const resetKey = ref(0)
const keepContentModal = ref(false)

onMounted(() => {
  store.dispatch(COMMUNITY_PORTFOLIOS_STORE.ACTIONS.SET_PORTFOLIOS_DEPARTMENTS, router.currentRoute.value.params.id)
  formData.value.content = ''
  requiredFromDate.value = true
  const modal = document.getElementById('addWorkModal')
  modal?.addEventListener('hide.bs.modal', clickOutside)
})

const responseServerError = (type: string): void => {
  serverErrorPortfolios.value = type
}

const onHideModalConfirm = (getBack) => {
  keepContentModal.value = false
  if (getBack) {
    emit('toogleModalAddWork', 'show')
    return
  }
  clickOutside()
}

const rules = computed(() => {
  return {
    affiliation: {
      requiredSelect: function (value) {
        if (value) return true
      },
    },
    department: {
      required,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, MAX_WORD),
      pictograms: function (value) {
        if (value) {
          return REGEX_EMOJI.test(value)
        } else {
          return true
        }
      },
    },
    position: {
      required,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, MAX_WORD),
      pictograms: function (value) {
        if (value) {
          return REGEX_EMOJI.test(value)
        } else {
          return true
        }
      },
    },
    // enrollmentPeriod: { required },
    fromDate: {
      required,
      maxDateNyears: function (value) {
        const date = dayjs().add(10, 'year').startOf('month').format('YYYY-MM-DD')
        const datePast = dayjs('1900/01/01').format('YYYY-MM-DD')

        if (dayjs(date).isBefore(dayjs(value))) {
          return false
        }
        if (dayjs(value).isBefore(dayjs(datePast))) {
          return false
        }
        return true
      },
    },
    toDate: {
      maxDateNyears: function (value) {
        const date = dayjs().add(10, 'year').startOf('month').format('YYYY-MM-DD')
        const datePast = dayjs('1900/01/01').format('YYYY-MM-DD')

        if (dayjs(date).isBefore(dayjs(value))) {
          return false
        }
        if (dayjs(value).isBefore(dayjs(datePast))) {
          return false
        }
        return true
      },
      afterStartDate: function (value) {
        return value ? dayjs(value).isSameOrAfter(dayjs(formData.value.fromDate)) : true
      },
    },
    content: {
      requiredDetails: function (value) {
        return !!value
      },
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, 200),
      pictograms: function (value) {
        if (value) {
          return REGEX_EMOJI.test(value)
        } else {
          return true
        }
      },
    },
    job_type_parent_id: {
      requiredSelect: function (value) {
        if (value) return true
      },
    },
    job_type_child_id: {
      requiredSelect: function (value) {
        if (value) return true
      },
    },
  }
})

const formData = ref({
  affiliation: '',
  department: '',
  // enrollmentPeriod: Date.now(),
  fromDate: '',
  toDate: '',
  position: '',
  content: '',
  job_type_parent_id: '',
  job_type_child_id: '',
})

// 2022/10/05 PhucNV Fix bug when edit work history, the major/minor category values not saved UAT#4566: SG43(Ph2-R20221007)
const formDataEdit = ref({
  affiliation: null,
  department: null,
  fromDate: null,
  toDate: null,
  position: null,
  content: null,
  job_type_parent_id: null,
  job_type_child_id: null,
})

const clickOutside = () => {
  if (keepContentModal.value) return
  resetDataEdit()
}

const resetDataEdit = () => {
  if (props.idWork) {
    const listWork = portfolios.value?.find((item: any) => Number(item.id) === Number(props.idCorporation)).portfolio_work_histories
    const itemWork = listWork.find((item: any) => Number(item.id) === Number(props.idWork))
    v$.value.$reset()
    formDataEdit.value.affiliation = itemWork?.portfolio_work_history_corporation_id
    formDataEdit.value.department = itemWork?.department_name
    formDataEdit.value.fromDate = itemWork?.start_period
    formDataEdit.value.toDate = itemWork?.end_period
    formDataEdit.value.position = itemWork?.position
    formDataEdit.value.content = itemWork?.content
    formDataEdit.value.job_type_parent_id = itemWork?.job_type_parent_id
    formDataEdit.value.job_type_child_id = itemWork?.job_type_child_id

    // 2022/10/05 PhucNV Fix bug when edit work history, the major/minor category values not saved UAT#4566: SG43(Ph2-R20221007)
    formData.value = {
      affiliation: formDataEdit.value.affiliation || '',
      department: formDataEdit.value.department || '',
      fromDate: formDataEdit.value.fromDate || '',
      toDate: formDataEdit.value.toDate || '',
      position: formDataEdit.value.position || '',
      content: formDataEdit.value.content || '',
      job_type_parent_id: formDataEdit.value.job_type_parent_id || '',
      job_type_child_id: formDataEdit.value.job_type_child_id || '',
    }

    // 2022/10/05 PhucNV Fix bug when edit work history, the major/minor category values not saved UAT#4566: SG43(Ph2-R20221007)
    indexJob.value = listJobs.value?.findIndex((item: any) => Number(item.id) === Number(formDataEdit.value.job_type_parent_id || itemWork?.job_type_parent_id))
    subJob.value = listJobs.value[indexJob.value]?.child || []
    ngKeyDepartment.value = false
    ngKeyPosition.value = false
    ngKeyContent.value = false
  }
}

watch([() => props.idCorporation, () => props.idWork], () => {
  if (!props.idCorporation) {
    formData.value = {
      affiliation: '',
      department: '',
      // enrollmentPeriod: Date.now(),
      fromDate: '',
      toDate: '',
      position: '',
      content: '',
      job_type_parent_id: '',
      job_type_child_id: '',
    }
  } else {
    const listWork = portfolios.value?.find((item: any) => Number(item.id) === Number(props.idCorporation)).portfolio_work_histories
    const itemWork = listWork.find((item: any) => Number(item.id) === Number(props.idWork))

    formData.value = {
      affiliation: itemWork?.portfolio_work_history_corporation_id || '',
      department: itemWork?.department_name || '',
      // enrollmentPeriod: Date.now(),
      fromDate: itemWork?.start_period || dayjs().startOf('month').format('YYYY-MM-DD'),
      toDate: itemWork?.end_period || '',
      position: itemWork?.position || '',
      content: itemWork?.content || '',
      job_type_parent_id: itemWork?.job_type_parent_id || '',
      job_type_child_id: itemWork?.job_type_child_id || '',
    }

    indexJob.value = listJobs.value?.findIndex((item: any) => Number(item.id) === Number(itemWork?.job_type_parent_id))
    subJob.value = listJobs.value[indexJob.value]?.child || []
  }

  // change reset key to force re render component flat-pickr
  // neeed recreate flat-pickr to initial correctly future year added on event onReady
  // REDMINE-TICKET 12773
  resetKey.value += 1
})


const v$ = useVuelidate(rules, formData)
const dataSubmit = ref({})
const confirmModal = ref(null)

const onSubmit = async (): Promise<void> => {
  v$.value.$touch()
  if (!formData.value.fromDate) {
    requiredFromDate.value = true
  }

  const isCheckedNGItems: Array<{ value: boolean }> = [isCheckedNGDepartment, isCheckedNGPosition, isCheckedNGContent]
  isCheckedNGItems.forEach((checkedNGItem) => (checkedNGItem.value = false))
  await Promise.all([checkNGDepartment(), checkNGPosition(), checkNGContent()])
  while (!isCheckedNGItems.every((checkedNGItem) => checkedNGItem.value)) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }

  if (v$.value.$invalid || ngKeyDepartment.value || ngKeyPosition.value || ngKeyContent.value) {
    nextTick(() => {
      scrollToErrors('.invalid-feedback', '#addWorkModal')
    })
    return
  }

  const data = cloneDeep(formData.value)
  keepContentModal.value = true
  emit('toogleModalAddWork', 'hide')
  confirmModal.value.showConfirmModal()
  dataSubmit.value = data
  const itemParent = listJobs.value?.filter((item: any) => item.id === formData.value.job_type_parent_id)
  jobNameParent.value = itemParent[0].name
  jobNameChild.value = itemParent[0]?.child?.filter((item: any) => item.id === formData.value.job_type_child_id)[0].name
  departmentName.value = departments.value.filter((item: any) => item.id === formData.value.affiliation)[0].name
}

const resetForm = (): void => {
  v$.value.$reset()
  Object.assign(formData.value, {
    affiliation: '',
    department: '',
    // enrollmentPeriod: Date.now(),
    fromDate: null,
    toDate: null,
    position: '',
    content: '',
    job_type_parent_id: '',
    job_type_child_id: '',
  })
  requiredFromDate.value = false
  ngKeyDepartment.value = false
  ngKeyPosition.value = false
  ngKeyContent.value = false
  props.handleEditWork('', '')
  props.createDepartmentError('')
}

watchEffect(() => {
  if (listJobs.value?.length > 0 && indexJob.value) {
    subJob.value = listJobs.value[indexJob.value]?.child || []
  }
  if (!subJob.value?.length) {
    formData.value.job_type_child_id = ''
  }

  if (formData.value.fromDate) {
    requiredFromDate.value = true
  }
})

// 2022/09/23 CW-Phuong Fix for UAT Phase1#4275: SG43 (Ph1-R20220929)
watch([() => props.idCorporation, () => formData.value.job_type_parent_id, () => props.idWork], () => {
  indexJob.value = listJobs.value?.findIndex((item: any) => Number(item.id) === Number(formData.value.job_type_parent_id))
  subJob.value = listJobs.value[indexJob.value]?.child || []
  if (!props.idCorporation) {
    formData.value.job_type_child_id = ''
  } else {
    const jobParent = indexJob.value + 1
    const listWork = portfolios.value?.find((item: any) => Number(item.id) === Number(props.idCorporation))?.portfolio_work_histories
    const itemWork = listWork?.find((item: any) => Number(item.id) === Number(props.idWork))
    indexJob.value = listJobs.value?.findIndex((item: any) => Number(item.id) === Number(itemWork?.job_type_parent_id))
    subJob.value = listJobs.value[indexJob.value]?.child || []
    if (jobParent === itemWork?.job_type_parent_id) {
      formData.value.job_type_child_id = itemWork?.job_type_child_id
    } else {
      formData.value.job_type_child_id = ''

      // 2022/10/05 PhucNV Fix bug when edit work history, the major/minor category values not saved UAT#4566: SG43(Ph2-R20221007)
      formDataEdit.value = formData.value
    }
  }
})

// 2022/09/26 CW-Phuong Fix for UAT Phase1#4275: SG43 (Ph1-R20220929)
watch(
  () => formData.value.job_type_child_id,
  () => {
    // 2022/10/05 PhucNV Fix bug when edit work history, the major/minor category values not saved UAT#4566: SG43(Ph2-R20221007)
    formDataEdit.value = formData.value
    if (formDataEdit.value.job_type_parent_id !== '' || formDataEdit.value.job_type_child_id !== '') {
      formData.value = formDataEdit.value
    }
    indexJob.value = listJobs.value?.findIndex((item: any) => Number(item.id) === Number(formData.value.job_type_parent_id))
    subJob.value = listJobs.value[indexJob.value]?.child || []
  }
)

// 2022/10/05 PhucNV Fix bug when edit work history, the major/minor category values not saved UAT#4566: SG43(Ph2-R20221007)
watch(
  () => props.resetDataEditFlag,
  () => {
    formDataEdit.value = {
      affiliation: null,
      department: null,
      fromDate: null,
      toDate: null,
      position: null,
      content: null,
      job_type_parent_id: null,
      job_type_child_id: null,
    }
  }
)

// 2022/10/05 PhucNV Fix bug when edit work history, the major/minor category values not saved UAT#4566: SG43(Ph2-R20221007)
watch(
  [
    () => formData.value.affiliation,
    () => formData.value.department,
    () => formData.value.fromDate,
    () => formData.value.toDate,
    () => formData.value.position,
    () => formData.value.content,
  ],
  () => {
    formDataEdit.value = {
      affiliation: formData.value.affiliation,
      department: formData.value.department,
      fromDate: formData.value.fromDate || '',
      toDate: formData.value.toDate || '',
      position: formData.value.position,
      content: formData.value.content,
      job_type_parent_id: formData.value.job_type_parent_id,
      job_type_child_id: formData.value.job_type_child_id,
    }
  }
)

const isCheckedNGDepartment = { value: false }
const ngKeyDepartment = ref<boolean>(false)
const checkNGDepartment = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.department.$model })
  ngKeyDepartment.value = data.data?.data?.has_ngword
  isCheckedNGDepartment.value = true
}, 200)

const isCheckedNGPosition = { value: false }
const ngKeyPosition = ref<boolean>(false)
const checkNGPosition = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.position.$model })
  ngKeyPosition.value = data.data?.data?.has_ngword
  isCheckedNGPosition.value = true
}, 200)

const isCheckedNGContent = { value: false }
const ngKeyContent = ref<boolean>(false)
const checkNGContent = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.content.$model })
  ngKeyContent.value = data.data?.data?.has_ngword
  isCheckedNGContent.value = true
}, 200)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Button, {
      title: _unref(translate)('addWorkHistory'),
      type: 'secondary',
      "data-bs-toggle": 'modal',
      "data-bs-target": '#addWorkModal',
      onClick: resetForm
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(__props.idWork ? _unref(translate)('editWorkHistory') : _unref(translate)('addWorkHistory')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              onClick: resetForm,
              "aria-label": "Close"
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("form", {
              onSubmit: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["prevent"]))
            }, [
              (__props.errorCreateDepartment)
                ? (_openBlock(), _createBlock(ErrorMessage, {
                    key: 0,
                    title: _unref(translate)(__props.errorCreateDepartment === 'VALIDATE_DUPLICATE' ? 'SG43createSameDepartment' : 'SG43createDepartmentError')
                  }, null, 8, ["title"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(translate)('affiliation')), 1),
                  _createVNode(Status)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("select", {
                      class: _normalizeClass(["form-select me-2", ['form-control', _unref(v$).affiliation.$error ? 'is-invalid' : '']]),
                      "aria-label": "Default select example",
                      name: "affiliation",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).affiliation.$model) = $event))
                    }, [
                      _createElementVNode("option", _hoisted_12, _toDisplayString(_unref(translate)('placeholderSelect')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(departments), (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: item.id,
                          value: item.id
                        }, _toDisplayString(item.name), 9, _hoisted_13))
                      }), 128))
                    ], 2), [
                      [_vModelSelect, _unref(v$).affiliation.$model]
                    ]),
                    _createVNode(InputErrorMessage, {
                      title: _unref(translate)('affiliation'),
                      validator: _unref(v$).affiliation.$errors[0]?.$validator
                    }, null, 8, ["title", "validator"])
                  ]),
                  _createElementVNode("div", {
                    class: "mt-1 icon cursor-pointer d-flex align-items-center justify-content-center rounded-circle",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#addAffiliation",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('resetAffiliationModal')))
                  }, _hoisted_15)
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_unref(translate)('department')), 1),
                  _createVNode(Status)
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "department",
                  class: _normalizeClass(['form-control', ngKeyDepartment.value || _unref(v$).department.$error ? 'is-invalid' : '']),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).department.$model) = $event)),
                  placeholder: _unref(translate)('placeholder'),
                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(checkNGDepartment) && _unref(checkNGDepartment)(...args)))
                }, null, 42, _hoisted_19), [
                  [
                    _vModelText,
                    _unref(v$).department.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (ngKeyDepartment.value && !_unref(v$).department.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                  : _createCommentVNode("", true),
                _createVNode(InputErrorMessage, {
                  title: 'department',
                  params: [1, 100],
                  validator: _unref(v$).department.$errors[0]?.$validator
                }, null, 8, ["validator"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_unref(translate)('occupation')), 1),
                  _createVNode(Status)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", _hoisted_25, _toDisplayString(_unref(translate)('SA20mainJob')), 1),
                  _createElementVNode("div", _hoisted_26, [
                    _withDirectives(_createElementVNode("select", {
                      class: _normalizeClass(["form-select", ['form-control', _unref(v$).job_type_parent_id.$error ? 'is-invalid' : '']]),
                      "aria-label": "Default select example",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).job_type_parent_id.$model) = $event))
                    }, [
                      _createElementVNode("option", _hoisted_27, _toDisplayString(_unref(translate)('placeholderSelect')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listJobs), (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: item.id,
                          key: item.id
                        }, _toDisplayString(item.name), 9, _hoisted_28))
                      }), 128))
                    ], 2), [
                      [_vModelSelect, _unref(v$).job_type_parent_id.$model]
                    ]),
                    _createVNode(InputErrorMessage, {
                      title: _unref(translate)('SA20mainJob'),
                      params: [1, 20],
                      validator: _unref(v$).job_type_parent_id.$errors[0]?.$validator
                    }, null, 8, ["title", "validator"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("label", _hoisted_30, _toDisplayString(_unref(translate)('SA20subJob')), 1),
                  _createElementVNode("div", _hoisted_31, [
                    _withDirectives(_createElementVNode("select", {
                      class: _normalizeClass(["form-select", ['form-control', _unref(v$).job_type_child_id.$error ? 'is-invalid' : '']]),
                      "aria-label": "Default select example",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(v$).job_type_child_id.$model) = $event))
                    }, [
                      _createElementVNode("option", _hoisted_32, _toDisplayString(_unref(translate)('placeholderSelect')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subJob.value, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: item.id,
                          key: item.id
                        }, _toDisplayString(item.name), 9, _hoisted_33))
                      }), 128))
                    ], 2), [
                      [_vModelSelect, _unref(v$).job_type_child_id.$model]
                    ]),
                    _createVNode(InputErrorMessage, {
                      title: _unref(translate)('SA20subJob'),
                      params: [1, 20],
                      validator: _unref(v$).job_type_child_id.$errors[0]?.$validator
                    }, null, 8, ["title", "validator"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("label", _hoisted_36, _toDisplayString(_unref(translate)('position')), 1),
                  _createVNode(Status)
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "position",
                  class: _normalizeClass(['form-control', ngKeyPosition.value || _unref(v$).position.$error ? 'is-invalid' : '']),
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(v$).position.$model) = $event)),
                  placeholder: _unref(translate)('placeholder'),
                  onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_unref(checkNGPosition) && _unref(checkNGPosition)(...args)))
                }, null, 42, _hoisted_37), [
                  [
                    _vModelText,
                    _unref(v$).position.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (ngKeyPosition.value && !_unref(v$).position.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                  : _createCommentVNode("", true),
                _createVNode(InputErrorMessage, {
                  title: 'position',
                  params: [1, 100],
                  validator: _unref(v$).position.$errors[0]?.$validator
                }, null, 8, ["validator"])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("label", _hoisted_41, _toDisplayString(_unref(translate)('enrollment')), 1),
                  _createVNode(Status)
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", null, [
                    (_openBlock(), _createElementBlock("div", {
                      class: "input-group",
                      key: resetKey.value
                    }, [
                      (props.idWork && _unref(v$).fromDate.$model)
                        ? (_openBlock(), _createBlock(_unref(flatPickr), {
                            key: 0,
                            modelValue: _unref(v$).fromDate.$model,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(v$).fromDate.$model) = $event)),
                            config: _unref(configYMPortfolio)(_unref(v$).fromDate.$model),
                            placeholder: "2000/01",
                            class: _normalizeClass(['form-control bg-white', _unref(v$).fromDate.$error ? 'is-invalid' : '']),
                            ref: (_value, _refs) => {
                              _refs['fromDateInput'] = _value
                              fromDateInput.value = _value
                            }
                          }, null, 8, ["modelValue", "config", "class"]))
                        : (_openBlock(), _createBlock(_unref(flatPickr), {
                            key: 1,
                            modelValue: _unref(v$).fromDate.$model,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(v$).fromDate.$model) = $event)),
                            config: _unref(configYMPortfolio)(new Date()),
                            placeholder: "2000/01",
                            class: _normalizeClass(['form-control bg-white', _unref(v$).fromDate.$error ? 'is-invalid' : '']),
                            ref: (_value, _refs) => {
                              _refs['fromDateInput'] = _value
                              fromDateInput.value = _value
                            }
                          }, null, 8, ["modelValue", "config", "class"])),
                      _hoisted_43
                    ])),
                    _createVNode(InputErrorMessage, {
                      title: '開始日',
                      validator: requiredFromDate.value ? _unref(v$).fromDate.$errors[0]?.$validator : '',
                      params: [1900, 1, 10]
                    }, null, 8, ["validator"])
                  ]),
                  _hoisted_44,
                  _createElementVNode("div", null, [
                    (_openBlock(), _createElementBlock("div", {
                      class: "input-group",
                      key: resetKey.value
                    }, [
                      (props.idWork && _unref(v$).toDate.$model)
                        ? (_openBlock(), _createBlock(_unref(flatPickr), {
                            key: 0,
                            modelValue: _unref(v$).toDate.$model,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(v$).toDate.$model) = $event)),
                            config: _unref(configYMPortfolio)(_unref(v$).toDate.$model),
                            placeholder: "2000/01",
                            class: _normalizeClass(['form-control bg-white', _unref(v$).toDate.$error ? 'is-invalid' : ''])
                          }, null, 8, ["modelValue", "config", "class"]))
                        : (_openBlock(), _createBlock(_unref(flatPickr), {
                            key: 1,
                            modelValue: _unref(v$).toDate.$model,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(v$).toDate.$model) = $event)),
                            config: _unref(configYMPortfolio)(new Date()),
                            placeholder: "2000/01",
                            class: _normalizeClass(['form-control bg-white', _unref(v$).toDate.$error ? 'is-invalid' : ''])
                          }, null, 8, ["modelValue", "config", "class"])),
                      _hoisted_45
                    ])),
                    _createVNode(InputErrorMessage, {
                      title: '終了',
                      validator: _unref(v$).toDate.$errors[0]?.$validator,
                      params: [1900, 1, 10]
                    }, null, 8, ["validator"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_46, _toDisplayString(_unref(translate)('SG43dateNote')), 1)
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("label", _hoisted_49, _toDisplayString(_unref(translate)('specificsContent')), 1),
                  _createVNode(Status)
                ]),
                _withDirectives(_createElementVNode("textarea", {
                  name: "content",
                  class: _normalizeClass(['form-control', ngKeyContent.value || _unref(v$).content.$error ? 'is-invalid' : '']),
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(v$).content.$model) = $event)),
                  placeholder: _unref(translate)('roleEtc'),
                  onChange: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_unref(checkNGContent) && _unref(checkNGContent)(...args)))
                }, null, 42, _hoisted_50), [
                  [
                    _vModelText,
                    _unref(v$).content.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (ngKeyContent.value && !_unref(v$).content.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                  : _createCommentVNode("", true),
                _createVNode(InputErrorMessage, {
                  title: 'specificsContent',
                  params: [1, 200],
                  validator: _unref(v$).content.$errors[0]?.$validator
                }, null, 8, ["validator"])
              ]),
              (!__props.idCorporation)
                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                    _createVNode(Button, {
                      class: "button-submit",
                      onClick: onSubmit,
                      title: _unref(translate)('signUp'),
                      type: 'secondary'
                    }, null, 8, ["title"])
                  ]))
                : _createCommentVNode("", true),
              (__props.idCorporation)
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _createVNode(Button, {
                        "data-bs-dismiss": "modal",
                        onClick: resetForm,
                        title: _unref(translate)('cancel'),
                        type: 'secondary',
                        className: 'button-confirm-modal'
                      }, null, 8, ["title"])
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _createVNode(Button, {
                        class: "button-submit",
                        type: 'secondary',
                        title: _unref(translate)('update'),
                        onClick: onSubmit
                      }, null, 8, ["title"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 32)
          ])
        ])
      ])
    ]),
    _createVNode(ConfirmModal, {
      responseServerError: responseServerError,
      data: dataSubmit.value,
      jobNameParent: jobNameParent.value,
      jobNameChild: jobNameChild.value,
      departmentName: departmentName.value,
      idCorporation: __props.idCorporation,
      idWork: __props.idWork,
      reset: resetForm,
      ref: (_value, _refs) => {
        _refs['confirmModal'] = _value
        confirmModal.value = _value
      },
      onOnHideModalConfirm: onHideModalConfirm
    }, null, 8, ["data", "jobNameParent", "jobNameChild", "departmentName", "idCorporation", "idWork"]),
    _createVNode(SuccessModal, {
      reset: resetForm,
      serverErrorPortfolios: serverErrorPortfolios.value,
      idCorporation: __props.idCorporation
    }, null, 8, ["serverErrorPortfolios", "idCorporation"])
  ], 64))
}
}

})